import { defineStore } from "pinia";
import { ref } from "vue";

import {
  type ContactResourceType,
  type ContactType,
} from "shared/composables/useContact";
import { type Nullable } from "shared/types";

export const useOutreachContactStore = defineStore("outreachContact", () => {
  const selectedContact = ref<Nullable<ContactType>>(null);

  const selectedContactResourceType = ref<Nullable<ContactResourceType>>(null);
  const isContactLoading = ref<boolean>(false);

  function reset() {
    selectedContact.value = null;
    selectedContactResourceType.value = null;
    isContactLoading.value = false;
  }

  return {
    isContactLoading,
    reset,
    selectedContact,
    selectedContactResourceType,
  };
});
